module.exports = __webpack_public_path__ + "static/media/21.e971d696.jpg";